// extracted by mini-css-extract-plugin
module.exports = {"action-tools":"index_action-tools_tuhpN","links":"index_links_2xzW2"};